var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c("auto-number-input", {
        staticStyle: { flex: "1" },
        attrs: { precision: 3, disabled: _vm.disabled, min: 0 },
        on: { change: _vm.onChange },
        model: {
          value: _vm.innerValue,
          callback: function($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue"
        }
      }),
      _c(
        "span",
        { staticStyle: { "min-width": "50px", "line-height": "28px" } },
        [_vm._v("M/T")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }